import { Switch, Route } from 'react-router-dom';

export const CustomerManage = ({ routes = [] }) => {
  return (
    <Switch>
      {routes.map((route) => (
        <Route key={route.path} {...route} />
      ))}
    </Switch>
  );
};
